/* Jewelry Boutique: small components on top of Dawn (announcement slider, card quick add). */
if (!customElements.get('jb-slider')) {
  customElements.define('jb-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.jb-ann__slide')];
      this.i = 0;
      if (this.slides.length < 2) return;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.i - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.i + 1, true));
      this.delay = parseInt(this.dataset.autoplay, 10) || 3000;
      this.start();
    }
    start() { clearInterval(this.t); this.t = setInterval(() => this.go(this.i + 1), this.delay); }
    go(n, user) {
      this.slides[this.i].classList.remove('is-active');
      this.i = (n + this.slides.length) % this.slides.length;
      this.slides[this.i].classList.add('is-active');
      if (user) this.start();
    }
  });
}

if (!customElements.get('jb-quick-add')) {
  customElements.define('jb-quick-add', class extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.jb-card__add');
      this.pick = this.querySelector('.jb-card__pick');
      this.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b || b.disabled) return;
        if (b.hasAttribute('data-open')) {
          const open = this.pick.hidden;
          this.pick.hidden = !open;
          b.setAttribute('aria-expanded', open);
          return;
        }
        if (b.dataset.variant) this.add(b.dataset.variant, b);
      });
    }
    async add(id, b) {
      const drawer = document.querySelector('cart-drawer');
      this.btn.classList.add('is-loading');
      try {
        const body = { items: [{ id: Number(id), quantity: 1 }] };
        if (drawer) body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
        const r = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
        });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Error');
        if (this.pick) { this.pick.hidden = true; }
        this.btn.classList.add('is-done');
        setTimeout(() => this.btn.classList.remove('is-done'), 1600);
        if (drawer) {
          data.id = data.items?.[0]?.id;
          drawer.renderContents(data);
          drawer.classList.remove('is-empty');
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      } catch (err) {
        window.location.href = this.dataset.url;
      } finally {
        this.btn.classList.remove('is-loading');
      }
    }
  });
}
